import React from 'react'
import { IModel } from '@linqpal/models'
import { BtInput } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'

const JobId: React.FC<{ model: IModel; value: string }> = ({
  model,
  value,
}) => {
  const { t } = useTranslation('global')
  return (
    <BtInput
      value={value}
      onChangeText={(val) => model.setValue(val)}
      label={t('ProjectForm.jobid-label')}
      testID="jobId"
    />
  )
}

export default {
  identifier: 'jobId',
  title: 'What is the Job ID?',
  component: JobId,
  optional: true,
}
